import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AboutModalService {
  private readonly modalOpenSubject = new Subject<void>();

  modalOpen$ = this.modalOpenSubject.asObservable();

  openAboutModal(): void {
    this.modalOpenSubject.next();
  }
}
